module.exports = __webpack_public_path__ + "static/media/payment.733f3b8e.svg";